module.exports = __webpack_public_path__ + "static/media/Tornax-OT-3200-TILE.44f0170d.png";